module.exports = __webpack_public_path__ + "img/autospin_btn.4ceeffc5.png";